const actions = {
  CAMPAIGN_DATA_FETCH_BEGIN: 'CAMPAIGN_DATA_FETCH_BEGIN',
  CAMPAIGN_DATA_FETCH_SUCCESS: 'CAMPAIGN_DATA_FETCH_SUCCESS',
  CAMPAIGN_DATA_FETCH_ERR: 'CAMPAIGN_DATA_FETCH_ERR',

  campaignDataFetchBegin: () => ({
    type: actions.CAMPAIGN_DATA_FETCH_BEGIN,
  }),

  campaignDataFetchSuccess: (data) => ({
    type: actions.CAMPAIGN_DATA_FETCH_SUCCESS,
    data,
  }),

  campaignDataFetchErr: (err) => ({
    type: actions.CAMPAIGN_DATA_FETCH_ERR,
    err,
  }),
};

export const {
  CAMPAIGN_DATA_FETCH_BEGIN,
  CAMPAIGN_DATA_FETCH_SUCCESS,
  CAMPAIGN_DATA_FETCH_ERR,
  campaignDataFetchBegin,
  campaignDataFetchSuccess,
  campaignDataFetchErr,
} = actions;

export default actions;
